export default "__VITE_ASSET__c68daf61__"